import { ElmApp, FromElm } from "types/elm";

import connect, { cleanupAllConnections } from "./connect";
import { refreshBanner } from "./refreshBanner";
import Sentry, { reportIssue } from "./sentry";
import { FromElmData } from "./types";
import { clearVerification, saveVerification } from "./verificationStorage";

const handlers: {
  [Tag in FromElm["tag"]]: (data: FromElmData<Tag>, app: ElmApp) => void;
} = {
  saveCaller(data) {
    if (data.phone) localStorage.setItem("caller.phone", data.phone);
    if (data.name) localStorage.setItem("caller.name", data.name);
    if (data.email) localStorage.setItem("caller.email", data.email);
    if (data.lastMedium)
      localStorage.setItem("caller.lastMedium", data.lastMedium);
  },
  breadcrumb(data) {
    Sentry.addBreadcrumb({
      category: "elm",
      message: "State transition",
      level: "info",
      data,
    });
  },
  error(data) {
    console.error("elm error: ", data.message);
    Sentry.captureMessage(data.message);
    cleanupAllConnections();
  },
  connect,
  saveVerification,
  clearVerification(_data) {
    clearVerification();
  },
  reset(_data) {
    localStorage.removeItem("caller.phone");
    localStorage.removeItem("caller.name");
    localStorage.removeItem("caller.email");
    localStorage.removeItem("caller.lastMedium");

    Sentry.addBreadcrumb({
      category: "elm",
      message: "reset",
      level: "info",
    });
    window.location.reload();
  },
  reload(_data) {
    window.location.reload();
  },
  issue(_data) {
    reportIssue();
  },
  refreshBanner,
  async playBeep(_data) {
    const audio = new Audio(
      "https://stw-static-twiml.s3.amazonaws.com/beep.mp3"
    );
    await audio.play();
  },
};

export default handlers;
